// src/components/parts/Sidebar.js
import { Link, useLocation } from 'react-router-dom';
import '../style/Sidebar.css';

const Sidebar = () => {
  const location = useLocation();

  // 1. Get User
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;
  
  // Get the role (prioritize role_key as that seems to be your DB standard)
  const userRole = user ? (user.role_key || user.role) : '';

  const menuItems = [
    // Admin Only
    { path: '/', label: 'Dashboard', icon: '🏠', allowedRoles: ['admin'] },
    
    // Public (All logged in users)
    { path: '/documents', label: 'Documents', icon: '📄', allowedRoles: ['admin','manager'] }, 
    { path: '/logos', label: 'Logos', icon: '🖼️', allowedRoles: ['admin','manager'] }, // <-- ADDED LOGOS HERE
    
    // Admin AND Account Manager 
    { path: '/users', label: 'Users', icon: '👥', allowedRoles: ['admin','system_admin'] },
    { path: '/groups', label: 'User Groups', icon: '👪', allowedRoles: ['admin'] },
    { path: '/user-sessions', label: 'User Session', icon: '💻', allowedRoles: ['admin'] },

    // Admin Only
    { path: '/hosts', label: 'Organisations', icon: '🏢', allowedRoles: ['admin'] },
    { path: '/categories', label: 'Categories', icon: '📚', allowedRoles: ['admin'] },
    { path: '/activity-log', label: 'Activity Log', icon: '📋', allowedRoles: ['admin'] },
    { path: '/devices', label: 'Device Manager', icon: '🔐', allowedRoles: ['admin'] }, 
    
    // DocuSign / Contract Templates (With Divider Above)
    { 
      path: '/contract-template', 
      label: 'Contract Templates', 
      icon: '✍️', 
      allowedRoles: ['admin'],
      hasDivider: true 
    },
  ];

  return (
    <nav className="sidebar">
      <ul className="sidebar-menu">
        {menuItems.map(item => {
          
          // 2. Check Permissions
          if (item.allowedRoles && item.allowedRoles.length > 0) {
            if (!item.allowedRoles.includes(userRole)) {
              return null; // Hide item
            }
          }

          // Create the Link Item
          const linkElement = (
            <li key={item.path}>
              <Link 
                to={item.path} 
                className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-label">{item.label}</span>
              </Link>
            </li>
          );

          // If item has a divider, return an array containing the divider and the link
          if (item.hasDivider) {
            return [
              <li key={`divider-${item.path}`} style={{ margin: '10px 15px', borderTop: '1px solid rgba(255,255,255,0.1)' }}></li>,
              linkElement
            ];
          }

          return linkElement;
        })}

        {/* Divider before Settings */}
        <li style={{ margin: '10px 15px', borderTop: '1px solid rgba(255,255,255,0.1)' }}></li>

        {/* 1. Main Settings Link */}
        <li key="/settings">
          <Link 
            to="/settings" 
            className={`menu-item ${location.pathname === '/settings' ? 'active' : ''}`}
          >
            <span className="menu-icon">⚙️</span>
            <span className="menu-label">Settings</span>
          </Link>
        </li>

        {/* 2. Email Settings (Sub-item, Admin Only) */}
        {userRole === 'admin' && (
          <li key="/email-settings">
            <Link 
              to="/email-settings" 
              className={`menu-item ${location.pathname === '/email-settings' ? 'active' : ''}`}
            >
              <span className="menu-icon">📧</span>
              <span className="menu-label">Email Alerts</span>
            </Link>
          </li>
        )}

      </ul>
    </nav>
  );
};

export default Sidebar;
